'use client';

import { BaseLink } from '../../navigation/HeaderRedesignBaseLink';
import { MDSText } from '@midwest/web/base';
import styled from 'styled-components';

export const LinksSubContainer = styled.div`
  flex: 1;
  display: flex;
  padding-top: 1rem;
  padding-right: 1rem;
  flex-direction: column;
  justify-content: flex-start;
`;

export const LinksColumnTitle = styled(MDSText.Subtitle)`
  font-size: 0.75rem;
  font-weight: 700;
  color: ${(p) => p.theme.midwestColors.identityBrandPrimaryHeavy};
  margin-bottom: 0.75rem;
  letter-spacing: 0.6px;
  text-transform: uppercase;
`;

export const AllProductsContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: flex-start;
  padding-left: 1rem;
`;

export const NavLink = styled(BaseLink)`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 0.75rem;
  color: ${(p) => p.theme.midwestColors.semanticColorSentimentInfoDense};
`;

export const MobileMenuPrimaryLink = styled(BaseLink)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 700;
  color: #be1d3d;
`;

export const LinksContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-bottom: 1px solid
    ${(p) => p.theme.midwestColors.semanticColorSentimentInfoWeak};
  padding-bottom: 2rem;
`;
export const SectionTitle = styled(MDSText.Subtitle)`
  font-size: 1.5rem;
  font-weight: 400;
  color: ${(p) => p.theme.midwestColors.identityBrandPrimaryHeavy};
  margin-bottom: 0.5rem;
`;

export const SectionSubTitle = styled(MDSText.BodyRegDefault)`
  font-size: 0.875rem;
  font-weight: 400;
  color: ${(p) => p.theme.midwestColors.identityBrandPrimaryHeavy};
  margin-bottom: 0.75rem;
`;
